export default defineNuxtPlugin(() => {
  // Enhanced hydration error logging
  if (import.meta.client) {
    // Override Vue's hydration error logging
    const originalError = console.error;
    console.error = (...args) => {
      if (args[0]?.includes?.("Hydration") || args[0]?.includes?.("mismatch")) {
        console.group("🚨 HYDRATION ERROR DETAILS");
        console.error("Original error:", ...args);
        console.log("Current URL:", window.location.href);
        console.log("User Agent:", navigator.userAgent);
        console.log("Viewport:", {
          width: window.innerWidth,
          height: window.innerHeight,
        });
        console.log("Document ready state:", document.readyState);
        console.log("Vue app mounted:", !!document.querySelector("#__nuxt"));
        console.groupEnd();
      }
      originalError.apply(console, args);
    };

    // Add global error handler for hydration mismatches
    window.addEventListener("error", (event) => {
      if (event.message?.includes("Hydration") || event.message?.includes("mismatch")) {
        console.group("🚨 HYDRATION ERROR - Window Error");
        console.error("Error:", event.error);
        console.log("Filename:", event.filename);
        console.log("Line:", event.lineno);
        console.log("Column:", event.colno);
        console.log("Stack:", event.error?.stack);
        console.groupEnd();
      }
    });

    // Add unhandled promise rejection handler
    window.addEventListener("unhandledrejection", (event) => {
      if (
        event.reason?.message?.includes("Hydration") ||
        event.reason?.message?.includes("mismatch")
      ) {
        console.group("🚨 HYDRATION ERROR - Unhandled Promise Rejection");
        console.error("Reason:", event.reason);
        console.log("Stack:", event.reason?.stack);
        console.groupEnd();
      }
    });
  }
});
